import * as yup from 'yup';

const merchantUserModel = {
  groupMid: "",
  role: "",
  userId : "",
  firstName : "",
  lastName : "",
  emailId : "",
  mobileNo : "",
  dept : ""
};

const merchantUserSchema = yup.object().shape({
  userId: yup.string()
    .required('Please Enter Valid Username')
    .min(6, 'Username should have at least 6 characters')
    .max(15, 'Username should not exceed 15 characters')
    .matches(/^[0-9A-Za-z ]{1,30}$/, 'Invalid Username format'),

  firstName: yup.string()
    .required('Please Enter First Name')
    .max(20, 'First name should not exceed 20 characters')
    .matches(/^[0-9A-Za-z ]{1,30}$/, 'Invalid First Name format'),

  lastName: yup.string()
    .required('Please Enter Last Name')
    .max(20, 'Last name should not exceed 20 characters')
    .matches(/^[0-9A-Za-z ]{1,30}$/, 'Invalid Last Name format'),

  mobileNo: yup.string()
    .required('Please Enter Valid Mobile Num')
    .matches(/^[0-9]{9,13}$/, 'Mobile number should be between 9 to 13 digits'),

  

  dept: yup.string()
    .max(20, 'Department should not exceed 20 characters'),

  role: yup.string().required('User Level is required'),

  groupMid: yup.string()
    .when('usrLvlCode', {
      is: 'MERCHANT',
      then: yup.string()
        .required('Group MID is required for Merchant')
        .matches(/^[a-zA-Z0-9]{15}$/, 'Invalid Group MID format'),
    }),
});

export { merchantUserSchema, merchantUserModel };